export const CONTRACT_TERM_SHOW_MODAL = "CONTRACT_TERM_SHOW_MODAL";
export const CONTRACT_TERM_HIDE_MODAL = "CONTRACT_TERM_HIDE_MODAL";
